/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './TransactionPendingTableV2.scss';

import React, {useEffect, useState} from 'react';
import { withRouter } from 'react-router-dom';


import { MUTUAL_FUND } from 'services/Products';
import LocalBeaconTable from '../../../shared/Table/BeaconTable';
import { getPendingTransactionsV2 } from "../../../../services/Rest";
import {buildTransactionPendingTable} from "./TransactionPageUtils";
import {isEmpty} from "lodash";
import TransactionPendingFiltersV2 from "./TransactionPendingFiltersV2";

const MAX_DAYS = 1095;


const TransactionPendingTableV2 = ({
                                     pendingTransactionTableData,
                                     filterOptions = []
}) => {

  const [transactionPendingTable, setTransactionHistoryTable] = useState(null);

  useEffect(() => {
    getPendingTransactionsV2(MAX_DAYS)
  }, []);

  console.log(pendingTransactionTableData, 'data');
  // Rebuild the table if the data or filters change
  useEffect(() => {
    if (!isEmpty(pendingTransactionTableData)) {
      setTransactionHistoryTable(
          buildTransactionPendingTable(
              pendingTransactionTableData?.transactionPendingData,
              pendingTransactionTableData?.transactionPendingAccounts,
              filterOptions
          )
      )
    }
  }, [filterOptions, pendingTransactionTableData]);

  if (!transactionPendingTable) {
    return null;
  }
  if(!(pendingTransactionTableData?.transactionPendingAccounts) || pendingTransactionTableData?.transactionPendingAccounts.length === 0) {
    return (
        <div className={'zero-state b-typography-sans-serif--body--100 b-font-weight-light b-margin-block-end--macro--jumbo b-padding--micro--jumbo'}>
          There is no pending transaction for the filter criteria selected
        </div>);
  }
  else {
    return (
        <div className="transactions-pending-table-container-v2 b-margin-block-end--macro--jumbo">
          <TransactionPendingFiltersV2
              filterOptions={filterOptions}
          />

          {(!(pendingTransactionTableData?.transactionPendingData) || pendingTransactionTableData?.transactionPendingData.length === 0) ? (
            <div className={'zero-state b-typography-sans-serif--body--100 b-font-weight-light b-margin-block-end--macro--jumbo b-padding--micro--jumbo'}>
                There is no pending transaction for the filter criteria selected
            </div>
          ) : (
            <LocalBeaconTable
                classType={'transactions-pending-table transactions-pending-table-v2'}
                idName={'transactions-pending-beacon-table-v2'}
                renderStickyRows={true}
                variant={'fixed'}
                headers={transactionPendingTable.headers}
                rowsArray={transactionPendingTable.rows}
            />
          )}
        </div>
    );
  }
};

TransactionPendingTableV2.defaultProps = {
  hasCollegeSavingsOnly: false,
  includePendingTransactions: false,
  productType: MUTUAL_FUND,
  viewMoreLink: ''
};

export default withRouter(TransactionPendingTableV2);
